export default "__VITE_ASSET__be03dbaa__"